<template>
  <div v-if="ready">
    <div class="row mb-2" v-if="screenSizeId >= 3">
      <div class="col-md-3">
        <div class="btn-group ml-1" role="group">
          <button type="button" class="btn btn-outline-primary" @click="prev"><i class="fas fa-angle-left"></i></button>
          <button type="button" class="btn btn-outline-primary" @click="next"><i class="fas fa-angle-right"></i></button>
          <button type="button" class="btn btn-outline-primary" @click="today">Now</button>
        </div>
      </div>
      <div class="col-md-6">
        <div class="d-flex justify-content-center">
          <h3>{{ `${modeClon=='year'?current.format("YYYY"):current.format("MMMM YYYY") }` }}</h3>
        </div>
      </div>
      <div class="col-md-3">
        <div class="d-flex justify-content-end">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-outline-primary" @click="modeClon = 'year'">Year</button>
            <button type="button" class="btn btn-outline-primary" @click="modeClon = 'month'">Month</button>
            <button type="button" class="btn btn-outline-primary" @click="modeClon = 'agenda'">Agenda</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-2" v-else>
      <div class="col-12">
        <div class="d-flex justify-content-center">
          <h4>{{ `${modeClon=='year'?current.format("YYYY"):current.format("MMMM YYYY") }` }}</h4>
        </div>
      </div>
      <div class="col-12 mt-2">
        <div class="d-flex justify-content-center">
          <div class="btn-group btn-block" role="group">
            <button type="button" class="btn btn-outline-primary btn-sm" @click="prev" title="Previous Month"><i class="fas fa-angle-left"></i></button>
            <button type="button" class="btn btn-outline-primary btn-sm" @click="next" title="Next Month"><i class="fas fa-angle-right"></i></button>
            <button type="button" class="btn btn-outline-primary btn-sm" @click="today">Now</button>
          </div>
        </div>
      </div>
      <div class="col-12 mt-1">
        <div class="d-flex justify-content-center">
          <div class="btn-group btn-block" role="group">
            <button type="button" class="btn btn-outline-primary btn-sm" @click="modeClon = 'year'">Year</button>
            <button type="button" class="btn btn-outline-primary btn-sm" @click="modeClon = 'month'">Month</button>
            <button type="button" class="btn btn-outline-primary btn-sm" @click="modeClon = 'agenda'">Agenda</button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <table class="calendar-table table table-sm table-bordered" v-if="modeClon=='month'">
        <thead>
          <tr class="c-weeks">
            <th class="c-name" v-for="day in weekDays">
              {{ day }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, week) in grid">
            <td class="calendar-day"
              v-for="(date, index) in row" :key="'calendar-day-month'+week+' '+index" 
              :class="[{'now': now.format('YYYY-MM-DD') === date.format('YYYY-MM-DD') , 'outside': current.month() != date.month() }]" 
              @click="onClick(date)"
              @mouseleave="onMouseLeave(date)"
              @mouseover="onMouseOver(date)"
              @focus="onFocus(date)"
              @blur="onBlur(date)"
              @keyup="onKeyPress(date)"
              @keypress.enter.prevent="onKeyPressEnter(date)"
              @keydown.tab="onKeyDownTab(date)"
              style="vertical-align: unset !important;"
            >
            <div class="date" v-if="showDate">{{date.format('D')}}</div>
            <slot :date="date" />
            </td>
          </tr>
        </tbody>
      </table>

      <table class="calendar-table table table-sm table-bordered" v-if="modeClon=='year'">
        <tbody v-if="grid">
            <tr>
              <th class="calendar-day" v-for="index in 4"  
                :class="[{'now': now.format('YYYY-MM') == current.clone().startOf('year').add(index-1, 'month').format('YYYY-MM')}]"
                @click="goMonth(current.clone().startOf('year').add(index-1, 'month'));onClick()"
                @mouseleave="onMouseLeave(current.clone().startOf('year').add(index-1, 'month'))"
                @mouseover="onMouseOver(current.clone().startOf('year').add(index-1, 'month'))"
                @focus="onFocus(current.clone().startOf('year').add(index-1, 'month'))"
                @blur="onBlur(current.clone().startOf('year').add(index-1, 'month'))"
                @keyup="onKeyPress(current.clone().startOf('year').add(index-1, 'month'))"
                @keypress.enter.prevent="onKeyPressEnter(current.clone().startOf('year').add(index-1, 'month'))"
                @keydown.tab="onKeyDownTab(current.clone().startOf('year').add(index-1, 'month'))"
              >
                {{ current.clone().startOf('year').add(index-1, 'month').format("MMMM") }}
              </th>
            </tr>
            <tr>
              <th class="calendar-day" v-for="index in 4"  
                :class="[{'now': now.format('YYYY-MM') == current.clone().startOf('year').add((index-1)+4, 'month').format('YYYY-MM')}]" 
                @click="goMonth(current.clone().startOf('year').add((index-1)+4, 'month'));onClick()"
                @mouseleave="onMouseLeave(current.clone().startOf('year').add((index-1)+4, 'month'))"
                @mouseover="onMouseOver(current.clone().startOf('year').add((index-1)+4, 'month'))"
                @focus="onFocus(current.clone().startOf('year').add((index-1)+4, 'month'))"
                @blur="onBlur(current.clone().startOf('year').add((index-1)+4, 'month'))"
                @keyup="onKeyPress(current.clone().startOf('year').add((index-1)+4, 'month'))"
                @keypress.enter.prevent="onKeyPressEnter(current.clone().startOf('year').add((index-1)+4, 'month'))"
                @keydown.tab="onKeyDownTab(current.clone().startOf('year').add((index-1)+4, 'month'))"
              >
              {{ current.clone().startOf('year').add((index-1)+4, 'month').format("MMMM")}}
              </th>
            </tr>
            <tr>
              <th class="calendar-day" v-for="index in 4"  
                :class="[{'now': now.format('YYYY-MM') == current.clone().startOf('year').add((index-1)+8, 'month').format('YYYY-MM')}]" 
                @click="goMonth(current.clone().startOf('year').add((index-1)+8, 'month'));onClick()"
                @mouseleave="onMouseLeave(current.clone().startOf('year').add((index-1)+8, 'month'))"
                @mouseover="onMouseOver(current.clone().startOf('year').add((index-1)+8, 'month'))"
                @focus="onFocus(current.clone().startOf('year').add((index-1)+8, 'month'))"
                @blur="onBlur(current.clone().startOf('year').add((index-1)+8, 'month'))"
                @keyup="onKeyPress(current.clone().startOf('year').add((index-1)+8, 'month'))"
                @keypress.enter.prevent="onKeyPressEnter(current.clone().startOf('year').add((index-1)+8, 'month'))"
                @keydown.tab="onKeyDownTab(current.clone().startOf('year').add((index-1)+8, 'month'))"
              >
              {{ current.clone().startOf('year').add((index-1)+8, 'month').format("MMMM")}}
              </th>
            </tr>
        </tbody>
      </table>

      <ul class="list-group" v-if="modeClon=='agenda'">
        <template v-for="row in grid">
          <template v-for="(date, index) in row">
            <template v-if="date.month() === current.month()">
              <li class="list-group-item" 
                :class="[{'list-group-item-primary': now.format('YYYY-MM-DD') == date.format('YYYY-MM-DD'), 'list-group-item-secondary': now.format('YYYY-MM-DD') != date.format('YYYY-MM-DD')}]" > 
                {{date.format("ddd, ll") }} 
              </li>
              <li class="list-group-item"
                @click="onClick(date)"
                @mouseleave="onMouseLeave(current.clone().startOf('year').add(index-1, 'month'))"
                @mouseover="onMouseOver(current.clone().startOf('year').add(index-1, 'month'))"
                @change="onChange(date)"
                @focus="onFocus(date)"
                @blur="onBlur(date)"
                @keyup="onKeyPress(date)"
                @keypress.enter.prevent="onKeyPressEnter(date)"
                @keydown.tab="onKeyDownTab(date)"
              >
              <slot :date="date"/>
              </li>
            </template>
          </template>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import checkPermissions from '../../mixins/checkPermissions'; 
export default {
  /**
    tag
    name: ks-calendar
    description: calendar component floating
  **/
  name: "ks-calendar",
  props:{
    showDate: { type: Boolean, default: true },
    mode:     { type:String, default: 'month' }
  },
  computed:{
    screenSizeId() {
      return app.layout.screenSizeId;
    }
  },
  mixins: [checkPermissions],
  watch:{
    mode: function(val) {
      this.modeClon = val;
    }
  },
  methods: {
    onKeyPress(date) {
      this.$emit('onKeyPress', {'ref':this, 'date':date});
    },
    onKeyPressEnter(date) {
      this.$emit('onKeyPressEnter', {'ref':this, 'date':date});
    },
    onKeyDownTab(date) {
      this.$emit('onKeyDownTab', {'ref':this, 'date':date});
    },
    onBlur(date) {
      this.$emit('onBlur', {'ref':this, 'date':date});
    },
    onFocus(date) {
      this.$emit('onFocus', {'ref':this, 'date':date});
    },
    onClick(date) {
      if(date !== undefined) this.$emit('onClick', {'ref':this, 'date':date});
    },
    onMouseLeave(date) {
      this.$emit('onMouseLeave', {'ref':this, 'date':date});
    },
    onMouseOver(date) {
      this.$emit('onMouseOver', {'ref':this, 'date':date});
    },
    goMonth(date){
      this.current = date;
      this.grid = this.getDayGrid(this.current.clone());
      this.modeClon = 'month';
      this.$emit('onMonth', this);
    },
    today(){
      if(this.modeClon === 'year') this.modeClon = 'month';
      this.current = moment();
      this.grid = this.getDayGrid(this.current.clone());
      this.$emit('onToday', this);
    },
    prev(){
      let mode = this.modeClon === 'agenda' ? 'month' : this.modeClon;
      this.current.startOf('month').subtract(1, mode);
      this.grid = this.getDayGrid(this.current.clone());
      this.$emit('onPrevious', this);
    },
    next(){
      let mode = this.modeClon === 'agenda' ? 'month' : this.modeClon;
      this.current.startOf('month').add(1,mode);
      this.grid = this.getDayGrid(this.current.clone());
      this.$emit('onNext', this);
    },
    getDayGrid(date){
      let grid = [];
      let firstDayOfWeek = date.clone().startOf('month').startOf('week');
      let aux = 0;
      for(let week = 0; week < 6 ; week ++){
        if(firstDayOfWeek.clone().add(aux, 'days') <= date.clone().endOf('month')){
          grid[week] = [];
          for(let day = 0; day < 7; day++){
            grid[week].push(firstDayOfWeek.clone().add(aux, 'days'));
            aux+=1;
          }
        }
      }
      return grid;
    },
    getComponentConfiguration(){
      return{
        mode: this.modeClon
        //current: this.current.clone().format('YYYY-MM-DD')
      }
    },
    setComponentConfiguration(config){
      for(let prop in config){
        if(prop === 'mode'){
          this.modeClon = config[prop];
        }else if(prop == 'current'){
          this.current = moment(config[prop], 'YYYY-MM-DD');
          this.grid = this.getDayGrid(this.current.clone());
        }
      }
    }
  },
  mounted(){
    this.now = moment();
    this.current = moment();
    this.grid = this.getDayGrid(this.now.clone());
    this.ready = true;
    this.modeClon = JSON.parse(JSON.stringify(this.mode));
  },
  data(){
    return {
      ready: false,
      weekDays: ["SUN","MON", "TUE", "WED", "THU","FRI", "SAT"],
      months: ['January','February','March','April','May','June','July','August','September','October','November','December'],
      current: null,
      now: null,
      grid: [],
      modeClon: null,
    }
  }
}

</script>

<style>
.calendar-table {
  margin: 0 auto;
}
.now{
  background-color: #cecece;
}
.selected {
  background-color: #eee;
}
.outside .date {
  color: #ccc;
}
.timetitle {
  white-space: nowrap;
  text-align: right;
}
.event {
  border-top: 1px solid #b2dba1;
  border-bottom: 1px solid #b2dba1;
  background-image: linear-gradient(to bottom, #dff0d8 0px, #c8e5bc 100%);
  background-repeat: repeat-x;
  color: #3c763d;
  border-width: 1px;
  font-size: .75em;
  padding: 0 .75em;
  line-height: 2em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 1px;
}
.event.begin {
  border-left: 1px solid #b2dba1;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.event.end {
  border-right: 1px solid #b2dba1;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.event.all-day {
  border-top: 1px solid #9acfea;
  border-bottom: 1px solid #9acfea;
  background-image: linear-gradient(to bottom, #d9edf7 0px, #b9def0 100%);
  background-repeat: repeat-x;
  color: #31708f;
  border-width: 1px;
}
.event.all-day.begin {
  border-left: 1px solid #9acfea;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.event.all-day.end {
  border-right: 1px solid #9acfea;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.event.clear {
  background: none;
  border: 1px solid transparent;
}
.table-tight > thead > tr > th,
.table-tight > tbody > tr > th,
.table-tight > tfoot > tr > th,
.table-tight > thead > tr > td,
.table-tight > tbody > tr > td,
.table-tight > tfoot > tr > td {
  padding-left: 0;
  padding-right: 0;
}
.table-tight-vert > thead > tr > th,
.table-tight-vert > tbody > tr > th,
.table-tight-vert > tfoot > tr > th,
.table-tight-vert > thead > tr > td,
.table-tight-vert > tbody > tr > td,
.table-tight-vert > tfoot > tr > td {
  padding-top: 0;
  padding-bottom: 0;
}
</style>